<template>
  <div class="layout">
    <PreorderTopNav />
    <main class="layout__main">
      <ErrorBoundary>
        <slot />
      </ErrorBoundary>
    </main>
  </div>
</template>

<style scoped>
.layout {
  min-height: 100svh;
  background: #050505;
  color: #ece6dc;
  overflow-x: clip;
}

.layout__main {
  isolation: isolate;
  padding-top: 0;
}
</style>
